<script setup>
/* global defineEmits, defineExpose */
import { ref, reactive, getCurrentInstance } from "vue";
import { ElMessage } from "element-plus";

const { appContext } = getCurrentInstance();

// 定义抛出的事件，用于通知父组件刷新列表
const emit = defineEmits(["refresh"]);

const dialogVisible = ref(false);
const submitLoading = ref(false);

// 新增：用于存储商户名称
const merchantName = ref("");

const form = reactive({
    merchant_id: null,
    enable_stat_offset: 0,
});

// 暴露给父组件的 open 方法，row 包含了该行的所有数据
const open = (row) => {
    form.merchant_id = row.id;
    form.enable_stat_offset = row.enable_stat_offset ?? 0;

    // 新增：将传入的商户名赋值给响应式变量（这里加上了简称，展示更清晰）
    merchantName.value = row.merchant_alias;

    dialogVisible.value = true;
};

// 提交表单
const handleSubmit = () => {
    submitLoading.value = true;
    appContext.config.globalProperties.$api.merchants
        .setStatOffsetEnabled({
            merchant_id: form.merchant_id,
            enable_stat_offset: form.enable_stat_offset,
        })
        .then((res) => {
            if (res.status == 200) {
                ElMessage.success("授权设置成功");
                dialogVisible.value = false;
                // 成功后通知父组件刷新数据
                emit("refresh");
            } else {
                ElMessage.error(res.message || "设置失败，请重试");
            }
        })
        .catch((err) => {
            console.error(err);
            ElMessage.error("接口请求异常");
        })
        .finally(() => {
            submitLoading.value = false;
        });
};

// 必须暴露出去，父组件的 ref 才能调用到
defineExpose({ open });
</script>

<template>
    <el-dialog v-model="dialogVisible" title="授权修改商户数据" width="450px" destroy-on-close>
        <el-form label-width="120px">
            <el-form-item label="当前商户：">
                <span>{{ merchantName }}</span>
            </el-form-item>

            <el-form-item label="统计偏移开关：">
                <el-switch v-model="form.enable_stat_offset" :active-value="1" :inactive-value="0" active-text="开启"
                    inactive-text="关闭" />
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
                    确认
                </el-button>
            </span>
        </template>
    </el-dialog>
</template>